import * as React from 'react';

import clsx from 'clsx';

import { MarketingCard } from '@/components/marketing';
import { overview } from '@/data/great-partner';

import { Button } from '../ui/Button';

export const GreatPartner = React.memo(({ onClick, ctaText }: { onClick?: () => void; ctaText?: string }) => {
  return (
    <>
      <div className='max-w-7xl mx-auto px-6 md:px-12 gap-8 sm:gap-12 lg:gap-x-20 grid sm:grid-cols-2 lg:grid-cols-5'>
        {overview.map((item, index) => (
          <div className={clsx(index === overview.length - 1 && 'sm:col-span-2 lg:col-span-1')} key={item.heading}>
            <MarketingCard copy={item.copy} heading={item.heading} image={item.image} />
          </div>
        ))}
      </div>

      <div className='w-full flex justify-center'>
        <Button className='mt-6 self-center' onClick={onClick} variant='primary'>
          {ctaText}
        </Button>
      </div>
    </>
  );
});

GreatPartner.displayName = 'GreatPartner';
